import { useEffect, useState } from "react";
import api from "../utils/api";

export default function TradeSettingsCard({ userId }) {
    const [loading, setLoading] = useState(true);
    const [s, setS] = useState({
        per_trade_risk_usd: 500,
        daily_risk_cap_usd: 1500,
        max_positions: 5,
        max_position_usd: 3000,
        auto_trade_enabled: 0,
    });
    const [msg, setMsg] = useState("");

    useEffect(() => {
        const run = async () => {
            setLoading(true);
            try {
                const { data } = await api.get("/api/trade/settings", { params: { user_id: userId } });
                setS(data);
            } catch { }
            setLoading(false);
        };
        run();
    }, [userId]);

    const save = async () => {
        try {
            await api.post("/api/trade/settings", { user_id: userId, ...s });
            setMsg("Saved!");
            setTimeout(() => setMsg(""), 1200);
        } catch {
            setMsg("Error");
        }
    };

    if (loading) return <div className="p-4 bg-zinc-900 rounded-2xl">Loading settings�</div>;

    return (
        <div className="p-4 bg-zinc-900 rounded-2xl space-y-3">
            <h3 className="text-lg font-semibold">Risk & Automation</h3>

            <div className="grid grid-cols-2 gap-2">
                <label className="text-sm">Per-Trade Risk ($)
                    <input type="number" className="w-full bg-zinc-800 rounded px-3 py-2"
                        value={s.per_trade_risk_usd}
                        onChange={e => setS({ ...s, per_trade_risk_usd: Number(e.target.value) })} />
                </label>
                <label className="text-sm">Daily Loss Cap ($)
                    <input type="number" className="w-full bg-zinc-800 rounded px-3 py-2"
                        value={s.daily_risk_cap_usd}
                        onChange={e => setS({ ...s, daily_risk_cap_usd: Number(e.target.value) })} />
                </label>
                <label className="text-sm">Max Positions
                    <input type="number" className="w-full bg-zinc-800 rounded px-3 py-2"
                        value={s.max_positions}
                        onChange={e => setS({ ...s, max_positions: Number(e.target.value) })} />
                </label>
                <label className="text-sm">Max Position Size ($)
                    <input type="number" className="w-full bg-zinc-800 rounded px-3 py-2"
                        value={s.max_position_usd}
                        onChange={e => setS({ ...s, max_position_usd: Number(e.target.value) })} />
                </label>
            </div>

            <label className="flex items-center gap-2 text-sm">
                <input type="checkbox"
                    checked={!!s.auto_trade_enabled}
                    onChange={e => setS({ ...s, auto_trade_enabled: e.target.checked ? 1 : 0 })} />
                Enable AI Auto-Trade
            </label>

            <button onClick={save} className="bg-blue-600 rounded px-4 py-2">Save Settings</button>
            {msg && <div className="text-xs text-zinc-400">{msg}</div>}
        </div>
    );
}
